import React from "react";
import MyTitle from "../myTitle";
import styleObj from "./style.module.scss";
import LazyLoad from "react-lazyload";
import title from "../../assets/imgs/Experience2021.png";

export default function Experience(props) {
  let { list, meta } = props;
  return (
    !!list.length && (
      <div className={styleObj["experience-wrap"]}>
        <MyTitle
          meta={meta}
          title={title}
          mainTitle="大咖体验"
          subTitle="EXPERIENCE"
        />
        <ul className={styleObj["experience-list"]}>
          {list.map((item, i) => (
            <li key={i} className={styleObj["card-wrap"]}>
              <a href={item.url} target="blank">
                <div className={styleObj["cover"]}>
                  <LazyLoad height={325}>
                    <img src={item.pic} alt="" />
                  </LazyLoad>
                </div>
                <div className={styleObj["desc-wrap"]}>
                  <div className={styleObj["title"]}>{item.title}</div>
                  <div className={styleObj["desc"]}>
                    <img
                      className={styleObj["avatar"]}
                      src={item.avatar}
                      alt=""
                    />
                    <span className={styleObj["nickname"]}>{item.author}</span>
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  );
}
